
import { StyleLinkProcessor } from './processors/StyleLinkProcessor';
import { EssentialStylesProcessor } from './processors/EssentialStylesProcessor';
import { ScopingStylesProcessor } from './processors/ScopingStylesProcessor';
import { FallbackStylesProcessor } from './processors/FallbackStylesProcessor';

/**
 * TailwindProcessor handles processing and loading of Tailwind CSS
 * 
 * This class provides utilities for securely loading Tailwind CSS in cross-origin environments
 * by completely avoiding CSS rule manipulation which can cause SecurityError
 */
export class TailwindProcessor {
  /**
   * Creates a secure method to load Tailwind CSS that works in cross-origin environments
   * @param cssUrl The URL of the CSS file to load
   * @param id Optional ID for the link element
   */
  static createStyleLink(cssUrl: string, id?: string): HTMLLinkElement {
    return StyleLinkProcessor.createStyleLink(cssUrl, id);
  }

  /**
   * Creates inline style element with critical CSS
   * that is guaranteed to work in any environment
   */
  static createEssentialStyles(): HTMLStyleElement {
    return EssentialStylesProcessor.createEssentialStyles();
  }

  /**
   * Creates a scoping style element to ensure styles are properly contained
   * within the shadow DOM
   */
  static createScopingStyles(): HTMLStyleElement {
    return ScopingStylesProcessor.createScopingStyles();
  }

  /**
   * Creates a fallback style to use when external CSS can't be loaded
   */
  static createFallbackStyles(): HTMLStyleElement {
    return FallbackStylesProcessor.createFallbackStyles();
  }
}
